// extracted by mini-css-extract-plugin
export default {"container":"screenTable_container__fajhP","headTitle":"screenTable_headTitle__AzgfD"};